import { render, staticRenderFns } from "./lt-logo.vue?vue&type=template&id=b30cac42&scoped=true"
var script = {}
import style0 from "./lt-logo.vue?vue&type=style&index=0&id=b30cac42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30cac42",
  null
  
)

export default component.exports